// main.tsx
import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './MainPage.css';
import appleStoreSvg from './appleStore.svg';
import googlePlayPng from './googlePlay.png';

const MainPage: React.FC = () => {
  const location = useLocation();
  const headingRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (location.state && (location.state as any).triggerAnimation && headingRef.current) {
      // Remove the animation class if it exists
      headingRef.current.classList.remove('top-down-animation');
      // Force reflow to reset the animation
      void headingRef.current.offsetWidth;
      // Add the class to trigger the animation
      headingRef.current.classList.add('top-down-animation');
    }
  }, [location]);

  const handleIOSDownload = () => {
    window.location.href = 'https://apps.apple.com/gb/app/camplocation/id6744300800';
  };

  const handleAndroidDownload = () => {
    window.location.href = 'https://play.google.com/store/apps/details?id=com.camplocation.campingapp';
  };

  return (
    <div className="page-content">
      <h1 ref={headingRef}>Welcome to Camplocation</h1>
      <p>Find your perfect spot</p>

      <div className="download-buttons">
        <img
          src={appleStoreSvg}
          alt="Download on the App Store"
          className="downloadIOS-button"
          onClick={handleIOSDownload}
        />
        <img
          src={googlePlayPng}
          alt="Get it on Google Play"
          className="downloadAndroid-button"
          onClick={handleAndroidDownload}
        />
      </div>
    </div>
  );
};

export default MainPage;